// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>

const VOUCHER_CONFIRMED_START_LOADING = 'VOUCHER_CONFIRMED_START_LOADING';
const VOUCHER_CONFIRMED_STOP_LOADING = 'VOUCHER_CONFIRMED_STOP_LOADING';

const VOUCHER_CONFIRMED_OPEN_CONFIRM_MODAL = 'VOUCHER_CONFIRMED_OPEN_CONFIRM_MODAL';
const VOUCHER_CONFIRMED_CLOSE_CONFIRM_MODAL = 'VOUCHER_CONFIRMED_CLOSE_CONFIRM_MODAL';

const VOUCHER_CONFIRMED_CHANGE_REDEEM_VALUE = 'VOUCHER_CONFIRMED_CHANGE_REDEEM_VALUE';
const VOUCHER_CONFIRMED_VALIDATE_REDEEM_VALUE = 'VOUCHER_CONFIRMED_VALIDATE_REDEEM_VALUE';
const VOUCHER_CONFIRMED_RESET_FORM = 'VOUCHER_CONFIRMED_RESET_FORM';

const VOUCHER_CONFIRMED_SET_BOOKSHOP_CUSTOMER = 'VOUCHER_CONFIRMED_SET_BOOKSHOP_CUSTOMER';

const VOUCHER_CONFIRMED_REDEEM_VOUCHER = 'VOUCHER_CONFIRMED_REDEEM_VOUCHER';
const VOUCHER_CONFIRMED_REDEEM_VOUCHER_SUCCESS = 'VOUCHER_CONFIRMED_REDEEM_VOUCHER_SUCCESS';

export {
  VOUCHER_CONFIRMED_START_LOADING,
  VOUCHER_CONFIRMED_STOP_LOADING,

  VOUCHER_CONFIRMED_CHANGE_REDEEM_VALUE,
  VOUCHER_CONFIRMED_VALIDATE_REDEEM_VALUE,
  VOUCHER_CONFIRMED_RESET_FORM,

  VOUCHER_CONFIRMED_SET_BOOKSHOP_CUSTOMER,

  VOUCHER_CONFIRMED_OPEN_CONFIRM_MODAL,
  VOUCHER_CONFIRMED_CLOSE_CONFIRM_MODAL,

  VOUCHER_CONFIRMED_REDEEM_VOUCHER,
  VOUCHER_CONFIRMED_REDEEM_VOUCHER_SUCCESS
};
